const BusinessPermissions = {
  MA: "Mortgages",
  GI: "General Insurance",
  PROT: "Protection",
  FP: "Financial Planning",
  LTC: "Long Term Care",
  ER: "Equity Release",
};

export default BusinessPermissions;
